




















































import { UseTabs } from "@/common/composition/use-tabs";
import PageWithMainContainer from "@/components/PageWithMainContainer.vue";
import SimpleNavTabs from "@/components/SimpleNavTabs.vue";
import { EventBus } from "@/eventbus";
import { computed, onMounted } from "@vue/composition-api";
import Vue from "vue";
import InformationLabels from "./information-labels/InformationLabels.vue";
import RiskTypes from "../in-motion/risk-types/RiskTypes.vue";
import { state as info_labels_state } from "./information-labels/data/state";
import { InfoTypeHelper } from "@/common/models";
import { SharedState } from "@/common/state";
export default Vue.extend({
  components: {
    PageWithMainContainer,
    SimpleNavTabs,
    InformationLabels,
    RiskTypes,
  },
  setup(_, { root: { $router } }) {
    const [tabs, current_tab, _set_current_tab] = UseTabs(
      [
        {
          id: "information",
          name: "Information Sensitivity",
          icon: "Label",
        },
        {
          id: "risk-types",
          name: "Event Risk Types",
          icon: "Events",
        },
      ],
      0
    );

    const set_current_tab = (tab: {
      id: string;
      name: string;
      icon: string;
    }) => {
      if (
        SharedState.restrictions.is_restricted_app("info_type_customization") &&
        tab.id == "information"
      ) {
        SharedState.restrictions.show_restrictions_modal(
          "app",
          "Information Customization"
        );
        return;
      }

      if (
        SharedState.restrictions.is_restricted_app("risk_type_customization") &&
        tab.id == "risk-types"
      ) {
        SharedState.restrictions.show_restrictions_modal(
          "app",
          "Risk Type Customization"
        );
        return;
      }
      _set_current_tab(tab);
    };

    const create_custom_label = () => {
      EventBus.emit("custom_label");
    };

    const create_custom_folder_context_label = () => {
      EventBus.emit("custom_folder_context_label");
    };

    onMounted(() => {
      SharedState.onReady(() => {
        if (
          SharedState.restrictions.is_restricted_app("info_type_customization")
        ) {
          // set to risk type customization app
          _set_current_tab(tabs.value[1]);
        }
      });
      const { action } = $router.currentRoute.query || {};
      if (action && action == "add_custom") {
        setTimeout(() => {
          create_custom_label();
        }, 200);
      }
    });

    return {
      tabs,
      current_tab,
      set_current_tab,
      create_custom_label,
      create_custom_folder_context_label,
      feature_custom_info_type_enabled: computed(() =>
        SharedState.FeatureHelper.is_enabled("custom_information_type")
      ),
      selected_content_labels_l0_is_not_personal: computed(
        () =>
          info_labels_state.selected_info_type.value?.id !==
          InfoTypeHelper.REGULATED_ID()
      ),
    };
  },
});
